<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
    export default {
        name: 'app',
        provide() {
            return {
                reload: this.reload
            }
        },
        data() {
            return {
                isRouterAlive: true
            }
        },
        methods: {
            reload() {
                this.isRouterAlive = false
                this.$nextTick(()=>{
                    this.isRouterAlive = true
                })
            }
        }
    }
</script>

<style lang="less">
#app {
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body {
  margin: 0;
}

.el-textarea__inner {
  border-radius: 0!important;
}

.header-row-oreki {
  background: #efefef;
}
.el-input-group__append {
  border-radius: 0!important;
}
.setting-list {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  .setting-btn {
    line-height: 27px;
    padding: 0 15px;
    font-size: 13px;
    color: #606266;
    cursor: pointer;
    outline: 0;
  }
  .setting-btn:hover {
    background-color: #e6f9fc;
    color: #33cde5;
  }
}

.border-all {
  /*border: 1px solid #E1E6EB;*/
}
@import "assets/font/iconfont.css";
@import "assets/font2/iconfont.css";
.iconfont {
  color: white;
  margin: 0 3px;
}
span:focus {
  outline-style: none;
}

.el-input__inner {
  border-radius: 0!important;
}
.popup-flex {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.el-pager li {
  color: #409EFF;
}

.el-popover {
  min-width: 100px!important;
}

.el-pager li.active {
  color: black!important;
}

.search-btn {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
}

.search-btn-pre {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.el-dialog__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  .el-dialog {
    margin: 15vh 0;
  }
}




.el-submenu__title {
  text-align: left;
}
.el-menu-item {
  text-align: left;
}


.el-button {
  border-radius: 0!important;
}

  .confirm-btn-blue {
    color: #FFF !important;
    background-color: #409EFF !important;
    border-color: #409EFF !important;
  }
  .el-icon-c-blue:before {
    content: "\e7a3";
    color: #409EFF;
  }
.confirm-btn-yellow {
  color: #FFF !important;
  background-color: #E5A13C !important;
  border-color: #E5A13C !important;
}
.el-icon-c-yellow:before {
  content: "\e7a3";
  color: #E5A13C;
}
.confirm-btn-red {
  color: #FFF !important;
  background-color: #F46C6C !important;
  border-color: #F46C6C !important;
}
.el-icon-c-red:before {
  content: "\e7a3";
  color: #F46C6C;
}


  .device{
    .el-button{
      padding: 5px 7px;
    }
  }
.el-loading-mask {
  background-color: rgba(0, 0, 0, 0.1)!important;
}
.redItem .el-form-item__label{
  color: red;
}
/*1.显示滚动条：当内容超出容器的时候，可以拖动：*/
.el-drawer__body {
  overflow: auto;
}

/*2.隐藏滚动条，太丑了*/
.el-drawer__container ::-webkit-scrollbar {
  display: none;
}

*::-webkit-scrollbar{display: none}
/**::-webkit-scrollbar {width:7px; height:10px; background-color:transparent;} !*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*!*/
/**::-webkit-scrollbar-track {background-color:#f0f6ff;  } !*定义滚动条轨道 内阴影+圆角*!*/
/**::-webkit-scrollbar-thumb {background-color:#73abb1; border-radius:6px;} !*定义滑块 内阴影+圆角*!*/
/*.scrollbarHide::-webkit-scrollbar{display: none}*/
/*.scrollbarShow::-webkit-scrollbar{display: block}*/

/*.el-submenu.is-active > .el-submenu__title {*/
  /*background: transparent !important;*/
/*}*/
/*.is-active{*/
  /*background: transparent !important;*/
/*}*/

</style>
